import React, { useEffect, useState } from "react";
import "./Dashboard.scss";
import useFullPageLoader from "common/UseFullPageLoader";
import { toastMessage } from "utils/toastMessage";
import { dashboardDataApi } from "services/dasboard";
import Chart from "react-apexcharts";
import {
  Chef,
  dashboard_user,
  green_user,
  indian_rupee,
  Notebook,
  red_user,
  star,
  trending_down,
  trending_up,
} from "assets/images";

const Dashboard = () => {
  const [linearData, setLinearData] = useState({});
  const [graphData, setGraphData] = useState([]);
  const [loader, onShow, onHide] = useFullPageLoader();

  const fetchingDashboardData = async () => {
    try {
      onShow();
      const { data, status } = await dashboardDataApi();
      if (status === 200) {
        setLinearData(data?.data);
        // setGraphData(data?.data);
      } else {
        toastMessage(data?.message, "error", "dashboardList");
        setLinearData({});
        setGraphData([]);
      }
    } catch (e) {
      console.log("error:", e.message);
    } finally {
      onHide();
    }
  };

  // Pie chart data from your subscriptionGraphData
  // const chartData = {
  //   series:
  //     (graphData &&
  //       graphData.length > 0 &&
  //       graphData.map((data) => data?.total)) ||
  //     [], // Totals from Gold, Silver, Platinum
  //   options: {
  //     chart: {
  //       type: "pie",
  //     },
  //     labels:
  //       (graphData &&
  //         graphData.length > 0 &&
  //         graphData.map((data) => data?.name)) ||
  //       [], // Name Of Subscription
  //     responsive: [
  //       {
  //         breakpoint: 480,
  //         options: {
  //           chart: {
  //             width: 200,
  //           },
  //           legend: {
  //             position: "bottom",
  //           },
  //         },
  //       },
  //     ],
  //   },
  // };
  useEffect(() => {
    fetchingDashboardData();
  }, []);

  const transactionRevenueData = {
    series: [
      {
        name: "Amount",
        data: ["100", "200", "150", "600", "400", "900"],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      // title: {
      //   // text: 'Product Trends by Month',
      //   align: 'left'
      // },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [
          "Week 1",
          "Week 2",
          "Week 3",
          "Week 4",
          "Week 5",
          "Week 6",
        ],
      },
    },
  };

  const isActiveUserGrow = ((linearData?.yesterdayUsers / linearData?.activeUsers) * 100) < 0 ? false : true;
  const isFeedbackGrow = ((linearData?.uptoLastWeekFeedback / linearData?.totalFeedback) * 100) < 0 ? false : true;
  const isArticleGrow = ((linearData?.uptoLastWeekArticles / linearData?.totalArticles) * 100) < 0 ? false : true;
  const isActivityGrow = ((linearData?.uptoLastWeekActivities / linearData?.totalActivities) * 100) < 0 ? false : true;
  const isRecipeGrow = ((linearData?.uptoLastWeekRecipe / linearData?.totalRecipe) * 100) < 0 ? false : true;

  return (
    <>
      {loader}
      <div className="dashboard_home">
        <h4>Dashboard</h4>
        <div className="container mt-4">
          <div className="row">

            {/* <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Users</h4>
                  </div>
                  <div className="user_icon">
                    <img src={dashboard_user} alt="" />
                  </div>
                </div>
                <div className="total_count">
                  <p>{(linearData && linearData?.totalUsers) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className="danger">4.3%</span> Down from YesterDay
                    </p>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Active Users</h4>
                  </div>

                  <div className="red_user_icon">
                    <img src={red_user} alt="" />
                  </div>
                </div>

                <div className="total_count">
                  <p>{(linearData && linearData?.activeUsers) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={isActiveUserGrow ? trending_up : trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className={isActiveUserGrow ? "green" : "red"}>{((linearData?.yesterdayUsers / linearData?.activeUsers) * 100).toFixed(2)}% </span> Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Inactive Users</h4>
                  </div>

                  <div className="green_user_icon">
                    <img src={green_user} alt="" />
                  </div>
                </div>

                <div className="total_count">
                  <p>{(linearData && linearData?.inactiveUsers) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className="danger">1.3%</span>Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Feedback</h4>
                  </div>

                  <div className="indian_rupee_icon">
                    <img src={indian_rupee} alt="" />
                  </div>
                </div>

                <div className="total_count">
                  <p>{(linearData && linearData?.totalFeedback) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={isFeedbackGrow ? trending_up : trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className={isFeedbackGrow ? "green" : "danger"}>{((linearData?.uptoLastWeekFeedback / linearData?.totalFeedback) * 100).toFixed(2)}%</span> Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Revenue</h4>
                  </div>

                  <div className="notebook_user_icon">
                    <img src={Notebook} alt="" />
                  </div>
                </div>
                <div className="total_count">
                  <p>{(linearData && linearData?.totalClasses) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className="danger">1.3%</span>Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Article</h4>
                  </div>

                  <div className="chef_user_icon">
                    <img src={Chef} alt="" />
                  </div>
                </div>

                <div className="total_count">
                  <p>{(linearData && linearData?.totalArticles) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={isArticleGrow ? trending_up : trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className={isArticleGrow ? "green" : "danger"}>{((linearData?.uptoLastWeekArticles / linearData?.totalArticles) * 100).toFixed(2)}%</span> Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Activities</h4>
                  </div>

                  <div className="user_icon">
                    <img src={star} alt="" />
                  </div>
                </div>

                <div className="total_count">
                  <p>{(linearData && linearData?.totalActivities) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={isActivityGrow ? trending_up : trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className={isActivityGrow ? "green" : "danger"}>{((linearData?.uptoLastWeekActivities / linearData?.totalActivities) * 100).toFixed(2)}%</span> Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-3">
              <div className="custom-card dashboard_card">
                <div className="wraper_content">
                  <div className="title">
                    <h4>Total Recipes</h4>
                  </div>

                  <div className="user_icon">
                    <img src={dashboard_user} alt="" />
                  </div>
                </div>
                <div className="total_count">
                  <p>{(linearData && linearData?.totalRecipe) || 0}</p>
                </div>

                <div className="card_bottom">
                  <div className="card_bottom_wraper">
                    <div className="downfall">
                      <img src={isRecipeGrow ? trending_up : trending_down} alt="downfall" />
                    </div>

                    <p className="status">
                      <span className={isActivityGrow ? "green" : "danger"}>{((linearData?.uptoLastWeekRecipe / linearData?.totalRecipe) * 100).toFixed(2)}%</span> Up from past week
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <div className="custom-card-pie">
                <h4>Revenue Generated</h4>
                <Chart
                  options={transactionRevenueData.options}
                  series={transactionRevenueData.series}
                  type="line"
                  // width="380"
                  height={"300"}
                />
              </div>
            </div>
          </div>

          {/* <div className="row mt-4">
            <div className="col-md-12">
              <div className="custom-card-pie">
                <h4>Donation Revenue</h4>
                <Chart
                  options={chartData.options}
                  series={chartData.series}
                  type="pie"
                  width="380"
                />
              </div>
            </div>
          </div> */}
          {/* <div className="row mt-4">
            <div className="col-md-12">
              <div className="custom-card-pie">
                <h4>Order Revenue</h4>
                <Chart
                  options={chartData.options}
                  series={chartData.series}
                  type="pie"
                  width="380"
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Dashboard;
